import React from 'react';

export default class QQBottomNav extends React.PureComponent {
  render() {
    const active = this.props.active;
    return (
      <nav id="qq-bottom-nav" aria-label="主导航">
        <button type="button" className={active === 'messages' ? 'active' : ''}
          onClick={() => this.props.onNavigate('contacts')}>
          <i className="material-icons">chat_bubble_outline</i>
          <span>消息</span>
          {this.props.unread > 0 ?
            <b className="qq-tab-badge">{this.props.unread > 99 ? '99+' : this.props.unread}</b> : null}
        </button>
        <button type="button" className={active === 'contacts' ? 'active' : ''}
          onClick={() => this.props.onNavigate('people')}>
          <i className="material-icons">people_outline</i>
          <span>联系人</span>
        </button>
        <button type="button" className={active === 'me' ? 'active' : ''}
          onClick={() => this.props.onNavigate('edit')}>
          <i className="material-icons">person_outline</i>
          <span>我</span>
        </button>
      </nav>
    );
  }
}
